import addWithClass from './addWithClass.js';
export default () => {
  addWithClass();
};